/* GOON WRLD theme motion. Every effect respects prefers-reduced-motion and the theme settings. */
(() => {
  const reduce = matchMedia("(prefers-reduced-motion: reduce)");
  const phone = matchMedia("(max-aspect-ratio: 3/4)");
  const fine = matchMedia("(pointer: fine)");
  const body = document.body;
  const flag = name => body.dataset[name] === "true";

  /* ---------- films: pick the desktop or phone file, still fallback ---------- */
  function film(v) {
    const src = phone.matches && v.dataset.srcMobile ? v.dataset.srcMobile : v.dataset.srcDesktop;
    const poster = phone.matches && v.dataset.posterMobile ? v.dataset.posterMobile : v.dataset.posterDesktop;
    const still = v.parentElement.querySelector(":scope > .still");
    if (poster) { v.poster = poster; if (still) still.src = poster; }
    if (reduce.matches || !src) { v.hidden = true; if (still) still.hidden = !poster; return; }
    v.hidden = false; if (still) still.hidden = true;
    if (v.getAttribute("src") !== src) { v.src = src; }
    v.onerror = () => { v.hidden = true; if (still) still.hidden = !poster; };
    if (v.dataset.autoplay === "true") v.play().catch(() => {});
  }

  /* ---------- raining wordmark ---------- */
  function wordmark(mark) {
    if (mark._anims) mark._anims.forEach(a => a.cancel());
    mark._anims = [];
    const L = JSON.parse(mark.dataset.layout);
    mark.style.setProperty("--ar", `${L.width} / ${L.height}`);
    mark.innerHTML = "";
    const imgs = L.letters.map(l => {
      const img = new Image(); img.alt = ""; img.src = l.src; img.decoding = "async";
      Object.assign(img.style, { left: `${l.x / L.width * 100}%`, top: `${l.y / L.height * 100}%`, width: `${l.w / L.width * 100}%`, height: `${l.h / L.height * 100}%` });
      mark.appendChild(img); return img;
    });
    if (reduce.matches) return;
    const gap = Number(mark.dataset.stagger || 140);
    const fall = mark.getBoundingClientRect().bottom + 40;
    imgs.forEach((img, i) => {
      const spin = (i % 2 ? 1 : -1) * (14 + (i * 7) % 18), drift = ((i * 37) % 11 - 5) * 4, delay = 350 + i * gap;
      mark._anims.push(img.animate([
        { transform: `translate(${drift}px, -${fall}px) rotate(${spin}deg)`, opacity: 0, offset: 0 },
        { opacity: 1, offset: .08 },
        { transform: "translate(0,0) rotate(0deg) scale(1.04,.9)", offset: .62, easing: "cubic-bezier(.2,.7,.3,1)" },
        { transform: `translate(0,-7%) rotate(${-spin * .06}deg) scale(.98,1.03)`, offset: .78, easing: "cubic-bezier(.5,0,.8,.4)" },
        { transform: "translate(0,0) scale(1.01,.98)", offset: .9 },
        { transform: "none", opacity: 1, offset: 1 }
      ], { duration: 1150, delay, easing: "cubic-bezier(.55,0,1,.45)", fill: "both" }));
    });
    if (mark.dataset.glint !== "true") return;
    const landed = 350 + (imgs.length - 1) * gap + 1150;
    imgs.forEach((img, i) => mark._anims.push(img.animate([
      { filter: "drop-shadow(0 .35vw .6vw rgba(0,0,0,.65)) brightness(1)" },
      { filter: "drop-shadow(0 0 1.2vw rgba(111,227,225,.55)) brightness(1.35)", offset: .06 },
      { filter: "drop-shadow(0 .35vw .6vw rgba(0,0,0,.65)) brightness(1)", offset: .14 },
      { filter: "drop-shadow(0 .35vw .6vw rgba(0,0,0,.65)) brightness(1)" }
    ], { duration: 5000, delay: landed + 300 + i * 70, iterations: Infinity })));
  }
  function heroTilt(hero) {
    const mark = hero.querySelector(".mark");
    hero.addEventListener("pointermove", e => {
      if (!mark || reduce.matches || e.pointerType !== "mouse") return;
      const r = hero.getBoundingClientRect();
      const dx = (e.clientX - r.left) / r.width - .5, dy = (e.clientY - r.top) / r.height - .5;
      mark.style.transform = `translateX(-50%) perspective(900px) rotateY(${dx * 6}deg) rotateX(${-dy * 5}deg)`;
    });
  }

  /* ---------- scroll scrubs time ---------- */
  const scrubs = [];
  function scrub(sec) {
    const v = sec.querySelector("video"), eras = JSON.parse(sec.dataset.eras || "[]");
    const s = { sec, v, eras, want: 0, raf: 0 };
    v.addEventListener("seeked", () => { if (Math.abs(v.currentTime - s.want) > 1 / 30) seek(s); });
    scrubs.push(s); update(s);
  }
  function seek(s) { s.raf = 0; if (!s.v.seeking && Math.abs(s.v.currentTime - s.want) > 1 / 30) s.v.currentTime = s.want; }
  function update(s) {
    const r = s.sec.getBoundingClientRect();
    const p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - innerHeight)));
    const dur = s.v.duration || Number(s.sec.dataset.duration || 30);
    s.want = p * Math.max(0, dur - .05);
    const fill = s.sec.querySelector(".bar i"), clock = s.sec.querySelector("[data-clock]"), era = s.sec.querySelector("[data-era]");
    if (fill) fill.style.width = `${p * 100}%`;
    if (clock) clock.textContent = `${s.want.toFixed(1).padStart(4, "0")} / ${dur.toFixed(1)} s`;
    if (era && s.eras.length) { const pct = p * 100; era.textContent = (s.eras.filter(e => pct >= e.at).pop() || s.eras[0]).label; }
    if (!s.raf && !reduce.matches && !s.v.hidden) s.raf = requestAnimationFrame(() => seek(s));
  }
  addEventListener("scroll", () => scrubs.forEach(update), { passive: true });

  /* ---------- product drop + slow-motion city ---------- */
  function drop(sec) {
    const cards = [...sec.querySelectorAll(".card")], v = sec.querySelector(":scope > video"), speed = sec.querySelector("[data-speed]");
    if (sec.dataset.dropIn === "true" && !reduce.matches && "IntersectionObserver" in window) {
      let done = false;
      new IntersectionObserver((es, ob) => es.forEach(e => {
        if (!e.isIntersecting || done) return;
        done = true; ob.disconnect();
        cards.forEach((c, i) => c.animate([
          { transform: "translateY(-70vh) rotate(-4deg)", opacity: .2 },
          { transform: "translateY(0) scale(1.02,.96)", opacity: 1, offset: .7 },
          { transform: "translateY(-12px)", offset: .85 },
          { transform: "none", opacity: 1 }
        ], { duration: 900, delay: i * 160, easing: "cubic-bezier(.55,0,1,.45)", fill: "backwards" }));
      }), { threshold: .3 }).observe(sec.querySelector(".grid"));
    }
    if (!v) return;
    const slow = Number(sec.dataset.slow || .2);
    let raf = 0;
    const ease = target => {
      cancelAnimationFrame(raf);
      const step = () => {
        const r = v.playbackRate + (target - v.playbackRate) * .12;
        v.playbackRate = Math.abs(r - target) < .01 ? target : r;
        if (speed) speed.textContent = `${v.playbackRate.toFixed(2)}×`;
        if (v.playbackRate !== target) raf = requestAnimationFrame(step);
      };
      step();
    };
    cards.forEach(c => {
      c.addEventListener("pointerenter", () => ease(slow)); c.addEventListener("pointerleave", () => ease(1));
      c.addEventListener("focus", () => ease(slow)); c.addEventListener("blur", () => ease(1));
    });
  }

  /* ---------- torn-paper page change ---------- */
  const tear = document.querySelector(".tear"), tc = tear && tear.querySelector("canvas"), tx = tc && tc.getContext("2d");
  function rip(after) {
    if (!tx || reduce.matches || !flag("tear")) { after(); return; }
    const dpr = devicePixelRatio || 1, w = tc.width = innerWidth * dpr, h = tc.height = innerHeight * dpr;
    let x = 0, s = Math.floor(Math.random() * 9999);
    const rnd = () => (s = (s * 9301 + 49297) % 233280) / 233280;
    const edge = []; for (let y = 0; y <= h + 8; y += 8) { x += (rnd() - .5) * 22; x *= .92; edge.push([(x + (rnd() - .5) * 6) * dpr, y]); }
    tear.style.display = "block";
    const T = 900, t0 = performance.now(); let swapped = false;
    const frame = now => {
      const k = Math.min(1, (now - t0) / T), e = k < .5 ? 2 * k * k : 1 - Math.pow(-2 * k + 2, 2) / 2;
      const front = -w * .15 + e * w * 2.3, back = front - w * 1.15;
      tx.clearRect(0, 0, w, h);
      const sheet = (lead, trail) => { tx.beginPath(); tx.moveTo(trail + edge[0][0], 0); edge.forEach(([ex, ey]) => tx.lineTo(lead + ex, ey));
        for (let i = edge.length - 1; i >= 0; i--) tx.lineTo(trail + edge[i][0] * .6, edge[i][1]); tx.closePath(); };
      tx.fillStyle = "#cfc8b8"; sheet(front + 10 * dpr, back - 10 * dpr); tx.fill();
      tx.fillStyle = "#0b0c0d"; sheet(front, back); tx.fill();
      if (!swapped && k > .45) { swapped = true; after(); }
      if (k < 1) requestAnimationFrame(frame); else { tear.style.display = "none"; }
    };
    requestAnimationFrame(frame);
  }
  document.addEventListener("click", e => {
    const a = e.target.closest("a[href]");
    if (!a || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (a.target && a.target !== "_self") return;
    const url = new URL(a.href, location.href);
    if (url.origin !== location.origin || a.hasAttribute("download") || a.dataset.noTear !== undefined) return;
    if (url.pathname === location.pathname && url.hash) return;
    if (!flag("tear") || reduce.matches || window.Shopify && Shopify.designMode) return;
    e.preventDefault();
    rip(() => { location.href = url.href; });
  });
  addEventListener("pageshow", e => { if (e.persisted && tear) tear.style.display = "none"; });

  /* ---------- money-scrap cursor ---------- */
  const scraps = (body.dataset.scraps || "").split(",").filter(Boolean);
  let lastScrap = 0;
  addEventListener("pointermove", e => {
    if (!flag("cursor") || !scraps.length || reduce.matches || !fine.matches || e.pointerType !== "mouse") return;
    const now = performance.now(); if (now - lastScrap < 70) return; lastScrap = now;
    const s = new Image(); s.className = "scrap"; s.alt = ""; s.src = scraps[Math.floor(Math.random() * scraps.length)];
    s.style.left = `${e.clientX - 22}px`; s.style.top = `${e.clientY - 22}px`;
    body.appendChild(s);
    const dx = (Math.random() - .5) * 120, dy = 60 + Math.random() * 120, rot = (Math.random() - .5) * 220;
    s.animate([{ transform: "scale(.6) rotate(0deg)", opacity: .95 }, { transform: `translate(${dx}px, ${dy}px) scale(.9) rotate(${rot}deg)`, opacity: 0 }],
      { duration: 1100 + Math.random() * 500, easing: "cubic-bezier(.2,.6,.4,1)" }).onfinish = () => s.remove();
  });

  /* ---------- film grain ---------- */
  const g = document.querySelector(".grain");
  if (g && flag("grain")) {
    const gx = g.getContext("2d");
    const frame = () => {
      const w = g.width = Math.ceil(innerWidth / 3), h = g.height = Math.ceil(innerHeight / 3);
      const img = gx.createImageData(w, h), d = img.data;
      for (let i = 0; i < d.length; i += 4) { const v = Math.random() * 255; d[i] = d[i + 1] = d[i + 2] = v; d[i + 3] = 255; }
      gx.putImageData(img, 0, 0);
    };
    frame();
    setInterval(() => { if (!reduce.matches && !document.hidden) frame(); }, 1000 / 12);
  } else if (g) g.hidden = true;

  /* ---------- product page: option buttons pick the variant ---------- */
  function productForm(form) {
    const data = form.querySelector("[data-variants]"); if (!data) return;
    const variants = JSON.parse(data.textContent), idInput = form.querySelector("[name=id]");
    const btn = form.querySelector("[data-add-btn]"), priceEl = document.querySelector("[data-price]");
    const sync = () => {
      const chosen = [...form.querySelectorAll("[data-option]")].map(fs => (fs.querySelector("input:checked") || {}).value);
      const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
      if (!v) { btn.disabled = true; btn.textContent = btn.dataset.labelUnavailable; return; }
      idInput.value = v.id;
      btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.labelAdd : btn.dataset.labelSoldout;
      if (priceEl) priceEl.innerHTML = v.price_html;
      const u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
    };
    form.addEventListener("change", e => { if (e.target.closest("[data-option]")) sync(); });
  }

  /* ---------- boot (and re-boot inside the theme editor) ---------- */
  function boot(root) {
    root.querySelectorAll("video[data-src-desktop]").forEach(film);
    root.querySelectorAll(".mark[data-layout]").forEach(wordmark);
    root.querySelectorAll(".hero").forEach(heroTilt);
    root.querySelectorAll(".scrub").forEach(scrub);
    root.querySelectorAll(".drop").forEach(drop);
    root.querySelectorAll("form[data-product-form]").forEach(productForm);
  }
  boot(document);
  phone.addEventListener("change", () => document.querySelectorAll("video[data-src-desktop]").forEach(film));
  reduce.addEventListener("change", () => boot(document));
  document.addEventListener("shopify:section:load", e => boot(e.target));
})();
